"use client"

import MessagePageCharge from "pazChargeComponents/general/MessagePageCharge"

export default function NotFound() {
  return (
    <MessagePageCharge
      text={"מצטערים, הגעתם לעמוד ללא מוצא"}
      imageDesktop={"/404desktop.png"}
      imageMobile={"/404mobile.png"}
      imageHeight={460}
      imageWidth={616}
    />
  )
}
